<script setup lang="ts">
import NotificationContainer from '../notification/NotificationContainer.vue'
import LoadingSpinner from '../base/LoadingSpinner.vue'
import { usePersonalAccountDataState } from '../../utilities/account/useAccountDataPersonal'
import AccountSidePanel from '../account/AccountSidePanel.vue'
import { isLegalProfile } from '../../utilities/investment-process/useUserProfileType'
import { useLegalAccountDataState } from '../../utilities/account/useAccountDataLegal'
import { watchEffect } from 'vue'
import OrdersPanel from './OrdersPanel.vue'
import { usePortfolio } from '../../utilities/portfolio/usePortfolio'

//@ts-ignore
const accountState = isLegalProfile() ? useLegalAccountDataState() : usePersonalAccountDataState()

const { getOrdersPerIssuerActiveItems, getOrdersPerIssuerCompletedItems } = usePortfolio()

watchEffect(async () => {
    await accountState.fetchAccountData()

    if (accountState.accountId) {
        getOrdersPerIssuerActiveItems(accountState.accountId)
        getOrdersPerIssuerCompletedItems(accountState.accountId)
    }
})
</script>

<template>
    <div class="bg-gray-50">
        <NotificationContainer />

        <main v-if="accountState.loaded" class="mb-8 mt-5 w-full space-y-8">
            <div class="grid max-w-3xl grid-cols-1 gap-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
                <div class="space-y-6 lg:col-span-2 lg:col-start-1">
                    <section>
                        <OrdersPanel />
                    </section>
                </div>

                <section class="lg:col-span-1 lg:col-start-3" aria-labelledby="user-profile">
                    <AccountSidePanel />
                </section>
            </div>
        </main>
        <div v-else class="flex h-[65vh] items-center justify-center">
            <LoadingSpinner class="h-10 w-10 fill-primary" />
        </div>
    </div>
</template>

<style scoped></style>
